import { useContext, useRef } from "react";
import { LayoutStateContext } from "../../contexts/layout_state";
import { useCssStateManager } from "../../hooks/use_css_state_manager";
import { useCustomRouter } from "../../hooks/use_custom_router";
import { prebuildData } from "../../lib/prebuild-data";
import { EventPane } from "../core/event_pane";
import { Text } from "../core/text";

type TProp = {
    handle: string;
    caption: string;
    selected: boolean;
};

export default function MenuItem({handle,caption,selected}:TProp)
{
    const { mobileDetect } = useContext(LayoutStateContext);
    const router = useCustomRouter();
    const { mobileSmallScreenCutoff: mobileSmallWidthCutoff } = mobileDetect;

    const cssStateManager = useCssStateManager(["item"]);
    cssStateManager.useProperty(selected,"selected");

    const routeRef = useRef<string>();
    const route = routeRef.current?routeRef.current:routeRef.current = (() =>{
        const collectionItem = prebuildData.getCollectionByHandle(handle);
        return collectionItem.route.split("{handle}").join(handle);
    })();

    const handleClick = () => router.push(route);

    const { collectionMenuBar: { menuHighlightTextColor,menuTextColor } } = prebuildData.getActiveTheme();

    return (
        <>
            <div className={cssStateManager.getClassNames()}>
                <Text>{caption}</Text>
                <EventPane onClick={handleClick} seoLinkUrl={route} />
            </div>
            <style jsx>{`
            .item {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 16.5rem;
                font-weight: 600;
                color: ${menuTextColor};
                padding: 0rem 18rem;
                cursor: pointer;
                transition: opacity 0.3s;
                white-space: nowrap;
                position: relative;
                transition: background-color var(--touch-duration);
            }

            .item.selected {
                color: ${menuHighlightTextColor};
            }

            @media screen and (max-width: ${mobileSmallWidthCutoff}px) {
                :global(html) .item {
                    font-size: 15rem;
                }
            }

            .item.hover
            {
                opacity: 0.75;
            }

            .item.touchdown {
                background-color: rgba(0,0,0,0.05);
            }
            `}</style>
        </>
    )
}